"use strict";
exports.__esModule = true;
var tslib_1 = require("tslib");
var Gradient_1 = require("./Gradient");
var RadialGradient = (function (_super) {
    tslib_1.__extends(RadialGradient, _super);
    function RadialGradient(x, y, r, colorStops, globalCoord) {
        var _this = _super.call(this, colorStops) || this;
        _this.x = x == null ? 0.5 : x;
        _this.y = y == null ? 0.5 : y;
        _this.r = r == null ? 0.5 : r;
        _this.type = 'radial';
        _this.global = globalCoord || false;
        return _this;
    }
    return RadialGradient;
}(Gradient_1["default"]));
exports["default"] = RadialGradient;
